import { render, staticRenderFns } from "./SocialPosting.vue?vue&type=template&id=77aa0600"
import script from "./SocialPosting.vue?vue&type=script&lang=js"
export * from "./SocialPosting.vue?vue&type=script&lang=js"
import style0 from "./SocialPosting.vue?vue&type=style&index=0&id=77aa0600&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports